export default {
  meta: {
    title: '我的'
  }
};
